import { FC } from 'react';

import AchAdd from 'components/ach-add';
import { ACH_ADD } from 'utils/constants';

const ACHMethod: FC = (): JSX.Element => <AchAdd intent={ACH_ADD} />;

export default ACHMethod;
